import type { ChatCallHistoryMetadata } from "@/types/chatCall";

type ChatListLastMessage = {
  content?: string | null;
  event_type?: string | null;
  eventType?: string | null;
  metadata?: ChatCallHistoryMetadata | Record<string, unknown> | null;
};

function formatDuration(durationSeconds?: number) {
  const totalSeconds = Math.max(0, Math.floor(durationSeconds || 0));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
}

function getCallDirectionLabel(
  metadata: ChatCallHistoryMetadata | null,
  currentUserId?: number,
) {
  if (!metadata || !currentUserId) {
    return "Chamada de voz";
  }

  if (metadata.callerId === currentUserId) {
    return "Você ligou";
  }

  if (metadata.calleeId === currentUserId) {
    return "Ligou para você";
  }

  return "Chamada de voz";
}

function getCallStatusPreview(
  metadata: ChatCallHistoryMetadata | null,
  currentUserId?: number,
) {
  const directionLabel = getCallDirectionLabel(metadata, currentUserId);

  switch (metadata?.status) {
    case "declined":
      return "Chamada recusada";
    case "cancelled":
      return "Chamada cancelada";
    case "missed":
      return "Chamada não atendida";
    case "connection_failed":
      return "Falha na chamada";
    case "microphone_denied":
      return "Microfone sem permissão";
    case "recipient_unavailable":
      return "Usuário indisponível";
    case "ended":
    case "in_progress":
    case "answered":
      return metadata.durationSeconds
        ? `${directionLabel} • ${formatDuration(metadata.durationSeconds)}`
        : directionLabel;
    default:
      return directionLabel;
  }
}

export function getChatLastMessagePreview(
  lastMessage?: ChatListLastMessage | null,
  currentUserId?: number,
  fallback = "Sem mensagens",
) {
  if (!lastMessage) return fallback;

  const eventType = lastMessage.event_type || lastMessage.eventType;
  if (eventType === "call") {
    return getCallStatusPreview(
      (lastMessage.metadata || null) as ChatCallHistoryMetadata | null,
      currentUserId,
    );
  }

  const content = lastMessage.content?.trim();
  return content || fallback;
}
